export default "__VITE_ASSET__3db311ec__"